/**
 * 产品选购推荐 + 对比工具
 * 路径 A（quiz）：问卷筛选 → 产品网格勾选 → 对比
 * 路径 B（browse）：Keychron 风格下拉选择器 → 卡片 → 参数表格
 */
(function () {
  'use strict';

  /* ── 配置 ── */
  const CFG = JSON.parse(
    document.querySelector('[data-compare-config]')?.textContent || '{}'
  );
  if (!CFG.shopUrl) return;


  /* ── 状态 ── */
  const S = {
    mode: 'browse',
    category: '',
    products: {},
    seriesMap: {},
    checked: [],
    filtered: null,
    quiz: { step: 0, answers: {}, questions: [] },
    slots: { 1: null, 2: null, 3: null, 4: null },
    diffOn: false,
    slotDiffOn: false,
  };

  /* ── DOM 缓存 ── */
  const $ = (sel, ctx) => (ctx || document).querySelector(sel);
  const $$ = (sel, ctx) => [...(ctx || document).querySelectorAll(sel)];

  /* ── 可搜索下拉组件 ── */
  function createCombo(selectEl) {
    const wrap = selectEl.closest('.pc-slot__select-wrap');
    if (!wrap || wrap.querySelector('.pc-combo')) return wrap?.querySelector('.pc-combo');

    const combo = document.createElement('div');
    combo.className = 'pc-combo' + (selectEl.disabled ? ' is-disabled' : '');

    const input = document.createElement('input');
    input.type = 'text';
    input.className = 'pc-combo__input';
    input.placeholder = selectEl.options[0]?.text || 'Select...';
    input.readOnly = false;
    input.autocomplete = 'off';

    const clearBtn = document.createElement('button');
    clearBtn.type = 'button';
    clearBtn.className = 'pc-combo__clear';
    clearBtn.innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M10.5 3.5L3.5 10.5M3.5 3.5l7 7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
    clearBtn.style.display = 'none';

    const list = document.createElement('div');
    list.className = 'pc-combo__list';

    combo.appendChild(input);
    combo.appendChild(clearBtn);
    combo.appendChild(list);
    wrap.insertBefore(combo, selectEl);

    let items = [];
    let focusIdx = -1;

    function updateClearBtn() {
      const arrow = wrap.querySelector('.pc-slot__arrow');
      if (input.value && !selectEl.disabled) {
        clearBtn.style.display = '';
        if (arrow) arrow.style.display = 'none';
      } else {
        clearBtn.style.display = 'none';
        if (arrow) arrow.style.display = '';
      }
    }

    function syncFromSelect() {
      items = [];
      list.innerHTML = '';
      for (let i = 1; i < selectEl.options.length; i++) {
        const o = selectEl.options[i];
        items.push({ value: o.value, text: o.textContent });
      }
      combo.classList.toggle('is-disabled', selectEl.disabled);
      if (selectEl.disabled) {
        input.value = '';
        input.placeholder = selectEl.options[0]?.text || 'Select...';
      }
      if (selectEl.value) {
        const sel = items.find((it) => it.value === selectEl.value);
        if (sel) input.value = sel.text;
      } else {
        input.value = '';
      }
      updateClearBtn();
    }

    function render(query) {
      list.innerHTML = '';
      focusIdx = -1;
      const q = (query || '').toLowerCase().trim();
      const filtered = q ? items.filter((it) => it.text.toLowerCase().includes(q)) : items;
      if (!filtered.length) {
        list.innerHTML = '<div class="pc-combo__empty">No results</div>';
        return;
      }
      filtered.forEach((it, i) => {
        const div = document.createElement('div');
        div.className = 'pc-combo__item' + (it.value === selectEl.value ? ' is-selected' : '');
        div.dataset.value = it.value;
        if (q) {
          const idx = it.text.toLowerCase().indexOf(q);
          div.innerHTML = it.text.slice(0, idx) + '<mark>' + it.text.slice(idx, idx + q.length) + '</mark>' + it.text.slice(idx + q.length);
        } else {
          div.textContent = it.text;
        }
        div.addEventListener('mousedown', (e) => {
          e.preventDefault();
          pick(it);
        });
        list.appendChild(div);
      });
    }

    function pick(it) {
      selectEl.value = it.value;
      input.value = it.text;
      close();
      updateClearBtn();
      selectEl.dispatchEvent(new Event('change', { bubbles: true }));
    }

    clearBtn.addEventListener('mousedown', (e) => {
      e.preventDefault();
      selectEl.value = '';
      input.value = '';
      updateClearBtn();
      selectEl.dispatchEvent(new Event('change', { bubbles: true }));
      input.focus();
      open();
    });

    function open() {
      if (selectEl.disabled) return;
      combo.classList.add('is-open');
      render(input.value);
    }

    function close() {
      combo.classList.remove('is-open');
      focusIdx = -1;
    }

    input.addEventListener('focus', () => {
      input.select();
      open();
    });
    input.addEventListener('input', () => {
      open();
      render(input.value);
      updateClearBtn();
    });
    input.addEventListener('blur', () => {
      setTimeout(close, 150);
    });
    input.addEventListener('keydown', (e) => {
      const listItems = list.querySelectorAll('.pc-combo__item');
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        focusIdx = Math.min(focusIdx + 1, listItems.length - 1);
        listItems.forEach((el, i) => el.classList.toggle('is-focused', i === focusIdx));
        if (listItems[focusIdx]) listItems[focusIdx].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        focusIdx = Math.max(focusIdx - 1, 0);
        listItems.forEach((el, i) => el.classList.toggle('is-focused', i === focusIdx));
        if (listItems[focusIdx]) listItems[focusIdx].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter') {
        e.preventDefault();
        if (focusIdx >= 0 && listItems[focusIdx]) {
          const val = listItems[focusIdx].dataset.value;
          const it = items.find((x) => x.value === val);
          if (it) pick(it);
        }
      } else if (e.key === 'Escape') {
        close();
        input.blur();
      }
    });

    syncFromSelect();
    combo._sync = syncFromSelect;
    return combo;
  }

  function syncAllCombos() {
    $$('.pc-slot__select').forEach((sel) => {
      const wrap = sel.closest('.pc-slot__select-wrap');
      const combo = wrap?.querySelector('.pc-combo');
      if (combo && combo._sync) combo._sync();
    });
  }

  /* ── 工具函数 ── */
  const stripHtml = (s) => {
    const d = document.createElement('div');
    d.innerHTML = s;
    return d.textContent || d.innerText || s;
  };

  /**
   * Shopify AJAX API 返回价格为字符串（如 "59.98"），单位是美元，不是分
   */
  const money = (raw) => {
    if (raw == null || raw === '') return '';
    const num = typeof raw === 'string' ? parseFloat(raw) : raw;
    if (isNaN(num)) return '';
    const fmt = CFG.moneyFormat || '${{amount}}';
    const result = fmt
      .replace('{{amount}}', num.toFixed(2))
      .replace('{{amount_no_decimals}}', Math.round(num))
      .replace('{{amount_with_comma_separator}}', num.toFixed(2).replace('.', ','))
      .replace('{{amount_with_apostrophe_separator}}', num.toFixed(2).replace('.', "'"));
    return stripHtml(result);
  };

  /**
   * 解析 Shopify Rich Text metafield JSON，提取 Key: Value 键值对
   * 支持 paragraph、list（ordered/unordered）、listItem 等多种结构
   * 每个叶子文本块视为一行，用正则提取 "Key: Value" 或 "Key：Value"
   * @returns {{ [normalizedKey: string]: { label: string, value: string } }}
   */
  function parseRichTextSpecs(raw) {
    const result = {};
    if (!raw) return result;

    let obj = raw;
    if (typeof raw === 'string') {
      try { obj = JSON.parse(raw); } catch (_) { return result; }
    }

    if (!obj || !obj.children) return result;

    const extractText = (node) => {
      if (!node) return '';
      if (node.value) return node.value;
      if (node.children) return node.children.map(extractText).join('');
      return '';
    };

    /**
     * 递归收集所有"叶子行"：paragraph 和 listItem 各算一行
     */
    const collectLines = (node) => {
      if (!node) return [];
      const lines = [];
      const t = node.type;
      if (t === 'paragraph' || t === 'listItem' || t === 'list-item') {
        const text = extractText(node).trim();
        if (text) lines.push(text);
      } else if (node.children) {
        for (const c of node.children) {
          lines.push(...collectLines(c));
        }
      }
      return lines;
    };

    const allLines = collectLines(obj);
    for (const line of allLines) {
      const m = line.match(/^(.+?)\s*[:：]\s*(.+)$/);
      if (m) {
        const originalLabel = m[1].trim();
        const k = originalLabel.toLowerCase().replace(/\s+/g, '_');
        result[k] = { label: originalLabel, value: m[2].trim() };
      }
    }
    return result;
  }

  /**
   * 初始化时解析 CFG.variantSpecs，构建缓存
   * S.variantSpecsCache: { productId: { variantId: { key: value } } }
   */
  function parseVariantSpecs() {
    S.variantSpecsCache = {};
    const vs = CFG.variantSpecs;
    if (!vs) return;
    for (const pid in vs) {
      S.variantSpecsCache[pid] = {};
      for (const vid in vs[pid]) {
        S.variantSpecsCache[pid][vid] = parseRichTextSpecs(vs[pid][vid]);
      }
    }
  }

  function variantHasSpecs(product, variantId) {
    if (!CFG.hideProductsWithoutSpecs) return true;
    const specs = S.variantSpecsCache?.[String(product.id)]?.[String(variantId)];
    return !!(specs && Object.keys(specs).length);
  }

  function productHasSpecs(product) {
    if (!CFG.hideProductsWithoutSpecs) return true;
    const productSpecs = S.variantSpecsCache?.[String(product.id)];
    if (!productSpecs) return false;
    return Object.values(productSpecs).some((specs) => specs && Object.keys(specs).length);
  }

  function getComparableVariants(product) {
    return (product.variants || []).filter((variant) => variantHasSpecs(product, variant.id));
  }

  /**
   * 获取产品规格值，三级回退：
   * 1. 指定 variant 的 metafield specs
   * 2. 产品下任意 variant 的 metafield specs（取第一个有值的）
   * 3. 产品 tags 匹配
   * @param {object} product - 产品对象
   * @param {string} key - spec key（小写下划线格式，如 weight）
   * @param {string|number} [variantId] - 可选，指定 variant ID
   * @returns {string} 规格值，无数据返回空字符串
   */
  const tagVal = (product, key, variantId) => {
    const pid = String(product.id);
    const k = key.toLowerCase().replace(/\s+/g, '_');
    const productSpecs = S.variantSpecsCache?.[pid];

    if (productSpecs) {
      if (variantId) {
        const vSpecs = productSpecs[String(variantId)];
        if (vSpecs?.[k]) return vSpecs[k].value;
      }
      for (const vid in productSpecs) {
        if (productSpecs[vid][k]) return productSpecs[vid][k].value;
      }
    }

    const prefix = key + '_';
    const tag = (product.tags || []).find((t) => t.startsWith(prefix));
    return tag ? tag.slice(prefix.length).replace(/_/g, ' ') : '';
  };

  /**
   * 从所有参与对比的产品中，收集 metafield 里出现过的所有 spec key
   * 返回去重且保持首次出现顺序的数组 [{ key, label }]
   */
  function collectSpecKeys(products, variantIds) {
    const seen = {};
    const keys = [];
    products.forEach((p, i) => {
      const pid = String(p.id);
      const productSpecs = S.variantSpecsCache?.[pid];
      if (!productSpecs) return;
      const vid = variantIds?.[i] ? String(variantIds[i]) : Object.keys(productSpecs)[0];
      const specs = productSpecs[vid] || {};
      for (const k in specs) {
        if (!seen[k]) {
          seen[k] = true;
          keys.push({ key: k, label: specs[k].label });
        }
      }
    });
    return keys;
  }

  const imgSrc = (src, size) =>
    src ? src.replace(/(\.\w+)(\?|$)/, `_${size}$1$2`) : '';

  /* ── 数据获取（带重试） ── */
  const fetchCache = {};

  async function fetchJson(url, retries) {
    for (let i = 0; i <= (retries || 2); i++) {
      try {
        const r = await fetch(url);
        if (r.ok) return await r.json();
      } catch (_) { /* 网络错误，重试 */ }
      if (i < (retries || 2)) await new Promise((r) => setTimeout(r, 800 * (i + 1)));
    }
    return null;
  }

  async function fetchCollection(handle) {
    if (fetchCache[handle]?.length) return fetchCache[handle];
    const all = [];
    let page = 1;
    while (true) {
      const d = await fetchJson(
        `${CFG.shopUrl}/collections/${handle}/products.json?limit=250&page=${page}`, 2
      );
      if (!d || !d.products || !d.products.length) break;
      all.push(...d.products);
      if (d.products.length < 250) break;
      page++;
    }
    if (all.length) fetchCache[handle] = all;
    return all;
  }

  /**
   * 加载当前分类下所有系列的产品
   * 同时构建 seriesMap：{ seriesHandle: { title, products[] } }
   */
  async function loadCategoryProducts(cat) {
    const catLower = cat.toLowerCase().trim();
    const series = (CFG.seriesCollections || []).filter(
      (s) => (s.category || '').toLowerCase().trim() === catLower
    );
    if (!series.length) {
      console.warn('[ProductCompare] No series found for category "' + cat + '". Available:', (CFG.seriesCollections || []).map(s => s.category));
    }

    /* 如果已有数据且不为空，直接返回 */
    if (S.products[cat]?.length && Object.keys(S.seriesMap[cat] || {}).length) {
      return S.products[cat];
    }

    S.products[cat] = [];
    S.seriesMap[cat] = {};

    if (series.length) {
      const results = await Promise.all(
        series.map((s) => fetchCollection(s.handle))
      );
      const seenIds = new Set();
      series.forEach((s, i) => {
        if (results[i]?.length) {
          const comparableProducts = results[i].filter(productHasSpecs);
          S.seriesMap[cat][s.handle] = { title: s.title, products: comparableProducts };
          comparableProducts.forEach((p) => {
            if (!seenIds.has(p.id)) {
              seenIds.add(p.id);
              S.products[cat].push(p);
            }
          });
        }
      });
    }
    return S.products[cat];
  }

  /* ============================================================
     初始化
     ============================================================ */

  function init() {
    if (!CFG.categories || !CFG.categories.length) return;
    parseVariantSpecs();
    S.category = CFG.categories[0].handle;
    initTabs();
    initModes();
    initQuizNav();
    initCompareBar();
    initBackButton();
    initSlotEvents();
    switchCategory(S.category);
  }

  /* ── 分类 Tab ── */
  function initTabs() {
    const tabs = $$('[data-category-tab]');
    tabs.forEach((btn) => {
      btn.addEventListener('click', () => {
        tabs.forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        switchCategory(btn.dataset.categoryTab);
      });
    });
    /* 默认高亮第一个 tab */
    if (tabs.length) {
      tabs.forEach((b) => b.classList.remove('is-active'));
      tabs[0].classList.add('is-active');
    }
  }

  async function switchCategory(handle) {
    S.category = handle;
    S.checked = [];
    S.filtered = null;
    S.filteredSkus = null;
    S.quiz = { step: 0, answers: {}, questions: getQuizQuestions(handle) };
    resetSlots();
    showLoading();
    await loadCategoryProducts(handle);
    hideLoading();
    setMode(S.mode);
  }

  /* ── 模式切换 ── */
  function initModes() {
    $$('[data-mode]').forEach((btn) => {
      btn.addEventListener('click', () => {
        $$('[data-mode]').forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        setMode(btn.dataset.mode);
      });
    });
  }

  function setMode(mode) {
    S.mode = mode;
    hideAllPanels();
    if (mode === 'quiz') {
      showQuiz();
    } else {
      showBrowse();
    }
  }

  function hideAllPanels() {
    $$('[data-panel]').forEach((p) => (p.style.display = 'none'));
    const bar = $('[data-compare-bar]');
    if (bar) bar.style.display = 'none';
    const result = $('[data-compare-result]');
    if (result) result.style.display = 'none';
  }

  /* ── Loading ── */
  function showLoading() {
    $$('[data-panel]').forEach((p) => (p.style.display = 'none'));
    let el = $('.pc-loading');
    if (!el) {
      el = document.createElement('div');
      el.className = 'pc-loading';
      el.innerHTML = '<div class="pc-loading__spinner"></div>';
      $('.shopify-section--product-compare .container').appendChild(el);
    }
    el.style.display = '';
  }
  function hideLoading() {
    const el = $('.pc-loading');
    if (el) el.style.display = 'none';
  }

  /* ============================================================
     路径 A：问卷
     ============================================================ */
  function getQuizQuestions(cat) {
    const c = cat.toLowerCase().trim();
    return (CFG.quizQuestions || []).filter((q) => (q.category || '').toLowerCase().trim() === c);
  }

  function showQuiz() {
    const panel = $('[data-panel="quiz"]');
    panel.style.display = '';
    if (S.quiz.questions.length) {
      renderAllQuestions();
    } else {
      S.filtered = null;
      showProductGrid();
    }
  }

  /**
   * 一次渲染所有问卷问题，每题一个区块
   */
  function renderAllQuestions() {
    const questions = S.quiz.questions;
    const container = $('[data-quiz-steps]');
    const submitBtn = $('[data-quiz-submit]');
    const errorEl = $('[data-quiz-error]');

    container.innerHTML = questions
      .map((q, i) => {
        const selected = S.quiz.answers[q.tagKey] || '';
        return `
        <div class="pc-quiz__step" data-quiz-question="${q.tagKey}">
          <span class="pc-quiz__step-counter">Question ${i + 1} of ${questions.length}</span>
          <h3 class="pc-quiz__step-label">${q.label}</h3>
          <div class="pc-quiz__options">
            ${(q.options || [])
              .map(
                (o) => `
              <button type="button" class="pc-quiz__option ${selected === o.value ? 'is-selected' : ''}" data-quiz-tag="${q.tagKey}" data-quiz-val="${o.value}">
                <span class="pc-quiz__option-label">${o.label}</span>
              </button>`
              )
              .join('')}
          </div>
          <p class="pc-quiz__field-error" data-field-error="${q.tagKey}" style="display:none">Please select an option</p>
        </div>`;
      })
      .join('');

    $$('.pc-quiz__option', container).forEach((btn) => {
      btn.addEventListener('click', () => {
        const tagKey = btn.dataset.quizTag;
        S.quiz.answers[tagKey] = btn.dataset.quizVal;
        const group = btn.closest('[data-quiz-question]');
        $$('.pc-quiz__option', group).forEach((b) => b.classList.remove('is-selected'));
        btn.classList.add('is-selected');
        const fieldErr = $(`[data-field-error="${tagKey}"]`);
        if (fieldErr) fieldErr.style.display = 'none';
        group.classList.remove('has-error');
        checkAllAnswered();
      });
    });

    function checkAllAnswered() {
      const allDone = questions.every((q) => S.quiz.answers[q.tagKey]);
      submitBtn.disabled = !allDone;
      if (allDone && errorEl) errorEl.style.display = 'none';
    }
    checkAllAnswered();
  }

  function initQuizNav() {
    $('[data-quiz-submit]')?.addEventListener('click', () => {
      const questions = S.quiz.questions;
      let hasError = false;
      questions.forEach((q) => {
        const fieldErr = $(`[data-field-error="${q.tagKey}"]`);
        const group = $(`[data-quiz-question="${q.tagKey}"]`);
        if (!S.quiz.answers[q.tagKey]) {
          hasError = true;
          if (fieldErr) fieldErr.style.display = '';
          if (group) group.classList.add('has-error');
        }
      });
      if (hasError) {
        const errorEl = $('[data-quiz-error]');
        if (errorEl) errorEl.style.display = '';
        const firstErr = $('.pc-quiz__step.has-error');
        if (firstErr) firstErr.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      finishQuiz();
    });
  }

  /**
   * 判断单个产品是否命中某条匹配规则
   * @param {object} product - 产品对象
   * @param {object} rule - 匹配规则 { key, contains, range, type }
   * @returns {boolean}
   */
  function matchSpec(product, rule) {
    if (!rule) return false;

    /* 价格范围匹配 */
    if (rule.type === 'price') {
      const price = parseFloat(product.variants?.[0]?.price);
      if (isNaN(price) || !rule.range) return false;
      return price >= rule.range[0] && price <= rule.range[1];
    }

    /* 从 metafield specs 取值（产品级别，遍历所有 variant 取第一个有值的） */
    const specVal = tagVal(product, rule.key || '');
    if (!specVal) return false;
    const lower = specVal.toLowerCase();

    /* contains：metafield 值包含任一关键词即命中 */
    if (rule.contains && rule.contains.length) {
      return rule.contains.some((kw) => lower.includes(kw.toLowerCase()));
    }

    /* range：从 metafield 值提取数字，判断是否在范围内 */
    if (rule.range) {
      const numMatch = specVal.match(/([\d.]+)/);
      if (!numMatch) return false;
      const num = parseFloat(numMatch[1]);
      return !isNaN(num) && num >= rule.range[0] && num <= rule.range[1];
    }

    return false;
  }

  /**
   * 对单个 variant 进行匹配评分
   * @param {object} product - 产品对象
   * @param {object} variant - variant 对象
   * @param {object} rule - 匹配规则
   * @returns {boolean}
   */
  function matchSpecVariant(product, variant, rule) {
    if (!rule) return false;
    if (rule.type === 'price') {
      const price = parseFloat(variant.price);
      if (isNaN(price) || !rule.range) return false;
      return price >= rule.range[0] && price <= rule.range[1];
    }
    const specVal = tagVal(product, rule.key || '', variant.id);
    if (!specVal) return false;
    const lower = specVal.toLowerCase();
    if (rule.contains && rule.contains.length) {
      return rule.contains.some((kw) => lower.includes(kw.toLowerCase()));
    }
    if (rule.range) {
      const numMatch = specVal.match(/([\d.]+)/);
      if (!numMatch) return false;
      const num = parseFloat(numMatch[1]);
      return !isNaN(num) && num >= rule.range[0] && num <= rule.range[1];
    }
    return false;
  }

  /**
   * 问卷完成：展开所有产品的 variant，逐个 SKU 评分排序
   */
  function finishQuiz() {
    const products = S.products[S.category] || [];
    const answers = S.quiz.answers;
    const questions = S.quiz.questions;
    const keys = Object.keys(answers);
    if (!keys.length) {
      S.filtered = null;
      showProductGrid();
      return;
    }

    const activeQs = [];
    keys.forEach((tagKey) => {
      const val = answers[tagKey].toLowerCase().trim();
      if (val === 'any' || val === '*') return;
      const q = questions.find((qq) => qq.tagKey === tagKey);
      if (!q) return;
      const selectedOption = (q.options || []).find((o) => o.value === answers[tagKey]);
      activeQs.push({ tagKey, answer: answers[tagKey], match: selectedOption?.match || null });
    });

    if (!activeQs.length) {
      S.filtered = null;
      showProductGrid();
      return;
    }

    const hardFilters = activeQs.filter((aq) => aq.match && aq.match.type === 'price');
    const softQs = activeQs.filter((aq) => !hardFilters.includes(aq));
    const total = softQs.length || 1;

    /* 展开每个产品的 variants，逐个 SKU 评分 */
    const skuList = [];
    products.forEach((p) => {
      getComparableVariants(p).forEach((v) => {
        if (hardFilters.length) {
          const passHard = hardFilters.every((aq) => matchSpecVariant(p, v, aq.match));
          if (!passHard) return;
        }
        let score = 0;
        softQs.forEach((aq) => {
          if (aq.match) {
            if (matchSpecVariant(p, v, aq.match)) score++;
          } else {
            if (tagVal(p, aq.tagKey, v.id).toLowerCase() === aq.answer.toLowerCase()) score++;
          }
        });
        skuList.push({
          product: p,
          variant: v,
          _score: score,
          _pct: Math.round((score / total) * 100),
        });
      });
    });

    skuList.sort((a, b) => b._score - a._score);
    const filtered = softQs.length ? skuList.filter((s) => s._score > 0) : skuList;
    S.filteredSkus = filtered.length ? filtered : skuList.slice(0, 6);
    S.filtered = null;
    $('[data-panel="quiz"]').style.display = 'none';
    showProductGrid();
  }

  /* ============================================================
     产品网格（问卷结果）
     ============================================================ */
  function showProductGrid() {
    const panel = $('[data-panel="products"]');
    panel.style.display = '';
    const grid = $('[data-product-grid]');
    const skuMode = !!(S.filteredSkus && S.filteredSkus.length);
    const countEl = $('[data-product-count]');
    const resetBtn = $('[data-reset-filter]');

    if (skuMode) {
      /* SKU 级别展示（问卷推荐结果） */
      const skus = S.filteredSkus.filter((s) => variantHasSpecs(s.product, s.variant.id));
      countEl.textContent = `${skus.length} SKUs found`;
      resetBtn.style.display = '';

      if (!skus.length) {
        grid.innerHTML =
          '<div class="pc-products__empty"><p>Comparison data is being added for this category. Please check back soon.</p></div>';
        return;
      }

      grid.innerHTML = skus
        .map((s) => {
          const p = s.product;
          const v = s.variant;
          const vImg = v.featured_image?.src || p.images?.[0]?.src || p.image?.src || '';
          const vTitle = v.title && v.title !== 'Default Title' ? `${p.title} - ${v.title}` : p.title;
          const checked = S.checked.includes(String(p.id) + '_' + String(v.id));
          const buyUrl = `${CFG.shopUrl}/products/${p.handle}?variant=${v.id}`;
          return `
          <div class="pc-product-card ${checked ? 'is-checked' : ''}" data-pid="${p.id}" data-vid="${v.id}">
            <div class="pc-product-card__check">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2.5 7L5.5 10L11.5 4" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </div>
            <img class="pc-product-card__image" src="${imgSrc(vImg, '300x300')}" alt="${vTitle}" loading="lazy" decoding="async" width="300" height="300">
            <h4 class="pc-product-card__title">${vTitle}</h4>
            <span class="pc-product-card__price">${money(v.price)}</span>
            <a class="pc-product-card__buy" href="${buyUrl}">Buy Now</a>
          </div>`;
        })
        .join('');

      $$('.pc-product-card', grid).forEach((card) => {
        card.addEventListener('click', (e) => {
          if (e.target.closest('.pc-product-card__buy')) return;
          const key = card.dataset.pid + '_' + card.dataset.vid;
          toggleCheck(key);
        });
      });
    } else {
      /* 产品级别展示（非问卷模式） */
      const items = (S.filtered || S.products[S.category] || []).filter(productHasSpecs);
      if (S.filtered) {
        countEl.textContent = `${items.length} products found`;
        resetBtn.style.display = '';
      } else {
        countEl.textContent = `All ${items.length} products`;
        resetBtn.style.display = 'none';
      }

      if (!items.length) {
        grid.innerHTML =
          '<div class="pc-products__empty"><p>Comparison data is being added for this category. Please check back soon.</p></div>';
        return;
      }

      grid.innerHTML = items
        .map((p) => {
          const img = p.images?.[0]?.src || p.image?.src || '';
          const checked = S.checked.includes(String(p.id));
          const seriesName = findSeriesName(p.id);
          return `
          <div class="pc-product-card ${checked ? 'is-checked' : ''}" data-pid="${p.id}">
            <div class="pc-product-card__check">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2.5 7L5.5 10L11.5 4" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </div>
            <img class="pc-product-card__image" src="${imgSrc(img, '300x300')}" alt="${p.title}" loading="lazy" decoding="async" width="300" height="300">
            <h4 class="pc-product-card__title">${p.title}</h4>
            ${seriesName ? `<p class="pc-product-card__series">${seriesName}</p>` : ''}
            <span class="pc-product-card__price">${money(p.variants?.[0]?.price)}</span>
          </div>`;
        })
        .join('');

      $$('.pc-product-card', grid).forEach((card) => {
        card.addEventListener('click', (e) => {
          if (e.target.closest('.pc-product-card__buy')) return;
          toggleCheck(card.dataset.pid);
        });
      });
    }

    updateCompareBar();

    resetBtn.onclick = () => {
      S.filtered = null;
      S.filteredSkus = null;
      S.checked = [];
      S.quiz = { step: 0, answers: {}, questions: getQuizQuestions(S.category) };
      panel.style.display = 'none';
      showQuiz();
    };

    const backBtn = $('[data-products-back]');
    if (backBtn) {
      backBtn.onclick = () => {
        S.filtered = null;
        S.filteredSkus = null;
        S.checked = [];
        panel.style.display = 'none';
        showQuiz();
      };
    }
  }

  function findSeriesName(pid) {
    const map = S.seriesMap[S.category] || {};
    for (const h in map) {
      if (map[h].products.some((p) => p.id === pid)) return map[h].title;
    }
    return '';
  }

  function toggleCheck(key) {
    key = String(key);
    const idx = S.checked.indexOf(key);
    if (idx >= 0) {
      S.checked.splice(idx, 1);
    } else {
      if (S.checked.length >= 4) return;
      S.checked.push(key);
    }
    /* 同步所有卡片的选中状态 */
    $$('.pc-product-card').forEach((c) => {
      const cardKey = c.dataset.vid
        ? String(c.dataset.pid) + '_' + String(c.dataset.vid)
        : String(c.dataset.pid);
      const isChecked = S.checked.indexOf(cardKey) >= 0;
      if (isChecked) {
        c.classList.add('is-checked');
      } else {
        c.classList.remove('is-checked');
      }
    });
    /* 强制更新按钮数字 */
    const topBtn = $('[data-top-compare]');
    const topCount = $('[data-top-compare-count]');
    if (topBtn) {
      topCount.textContent = S.checked.length;
      topBtn.style.display = S.checked.length > 0 ? '' : 'none';
    }
  }

  /* ── 顶部对比按钮 ── */
  function updateCompareBar() {
    const topBtn = $('[data-top-compare]');
    const topCount = $('[data-top-compare-count]');
    if (topBtn) {
      if (S.checked.length) {
        topBtn.style.display = '';
        topCount.textContent = S.checked.length;
      } else {
        topBtn.style.display = 'none';
      }
    }
  }

  function initCompareBar() {
    $('[data-top-compare]')?.addEventListener('click', () => {
      if (!S.checked.length) return;
      showQuizCompareResult();
    });
  }

  /* ── 问卷对比结果 ── */
  function showQuizCompareResult() {
    hideAllPanels();
    const panel = $('[data-compare-result]');
    panel.style.display = '';
    const allProducts = S.products[S.category] || [];
    const selectedEntries = S.checked
      .map((key) => {
        const [pid, vid] = String(key).split('_');
        const product = allProducts.find((x) => String(x.id) === pid);
        if (!product) return null;
        const variant = vid
          ? (product.variants || []).find((v) => String(v.id) === vid)
          : getComparableVariants(product)[0] || product.variants?.[0];
        if (!variant || !variantHasSpecs(product, variant.id)) return null;
        return { product, variant };
      })
      .filter(Boolean);
    const selected = selectedEntries.map((entry) => entry.product);
    const variantIds = selectedEntries.map((entry) => String(entry.variant.id));

    panel.style.setProperty('--compare-cols', selected.length);

    const cards = $('[data-compare-cards]');
    cards.innerHTML = selectedEntries
      .map(({ product: p, variant: v }) => {
        const title = v.title && v.title !== 'Default Title' ? `${p.title} - ${v.title}` : p.title;
        const img = v.featured_image?.src || p.images?.[0]?.src || p.image?.src || '';
        return `
        <div class="pc-compare-card">
          <img class="pc-compare-card__image" src="${imgSrc(img, '300x300')}" alt="${title}" loading="lazy" decoding="async" width="300" height="300">
          <h4 class="pc-compare-card__title">${title}</h4>
          <p class="pc-compare-card__price">${money(v.price)}</p>
          <a class="pc-compare-card__buy button button--primary" href="${CFG.shopUrl}/products/${p.handle}?variant=${v.id}">Buy Now</a>
        </div>`;
      })
      .join('');

    renderSpecTable(selected, '[data-compare-thead]', '[data-compare-tbody]', variantIds);
    initDiffToggle('[data-toggle-diff]', '[data-compare-tbody]');
  }

  function initBackButton() {
    $('[data-back-to-grid]')?.addEventListener('click', () => {
      $('[data-compare-result]').style.display = 'none';
      showProductGrid();
      $('[data-panel="products"]').style.display = '';
      updateCompareBar();
    });
  }

  /* ============================================================
     路径 B：Keychron 风格下拉选择
     ============================================================ */
  function showBrowse() {
    const panel = $('[data-panel="browse"]');
    panel.style.display = '';
    populateModelDropdowns();
    refreshSlotCards();
    refreshSlotTable();
  }

  /**
   * 根据当前分类，将所有产品直接填入 Model 下拉
   */
  function populateModelDropdowns() {
    const allProducts = S.products[S.category] || [];
    $$('[data-role="model"]').forEach((sel) => {
      const current = sel.value;
      sel.innerHTML = '<option value="">Select Model</option>';
      allProducts.forEach((p) => {
        const opt = document.createElement('option');
        opt.value = p.id;
        opt.textContent = p.title;
        sel.appendChild(opt);
      });
      sel.disabled = false;
      if (current && allProducts.some((p) => String(p.id) === current)) sel.value = current;
    });
    syncAllCombos();
  }

  function initSlotEvents() {
    /* 为所有 select 创建 combobox */
    $$('.pc-slot__select').forEach((sel) => createCombo(sel));

    /* Model 切换 → 填充 Variant 下拉，等 Variant 选择后才显示卡片 */
    $$('[data-role="model"]').forEach((sel) => {
      sel.addEventListener('change', () => {
        const slotIdx = sel.dataset.slot;
        const variantSel = $(`[data-role="variant"][data-slot="${slotIdx}"]`);
        variantSel.innerHTML = '<option value="">Select Variant</option>';
        variantSel.disabled = true;

        const pid = sel.value;
        if (!pid) {
          clearSlot(slotIdx);
          syncAllCombos();
          return;
        }
        const allProducts = S.products[S.category] || [];
        const product = allProducts.find((p) => String(p.id) === pid);
        if (!product) return;

        const variants = getComparableVariants(product);
        if (!variants.length) {
          clearSlot(slotIdx);
          syncAllCombos();
          return;
        }

        if (variants.length <= 1) {
          /* 只有一个 variant（Default Title），直接选中并显示 */
          S.slots[slotIdx] = product;
          S.slotVariant = S.slotVariant || {};
          S.slotVariant[slotIdx] = variants[0] || null;
          syncAllCombos();
          refreshSlotCard(slotIdx);
          refreshSlotTable();
          $(`[data-slot="${slotIdx}"]`)?.classList.add('has-product');
        } else {
          /* 多个 variant：先清空卡片，等用户选 variant */
          clearSlot(slotIdx);
          variants.forEach((v) => {
            const opt = document.createElement('option');
            opt.value = v.id;
            opt.textContent = v.title;
            variantSel.appendChild(opt);
          });
          variantSel.disabled = false;
          syncAllCombos();
        }
      });
    });

    /* Variant 切换 → 设置产品 + variant 并显示卡片 */
    $$('[data-role="variant"]').forEach((sel) => {
      sel.addEventListener('change', () => {
        const slotIdx = sel.dataset.slot;
        const vid = sel.value;
        if (!vid) {
          /* 清空卡片但保留 variant 下拉选项，让用户可以重新选 */
          S.slots[slotIdx] = null;
          if (S.slotVariant) S.slotVariant[slotIdx] = null;
          $(`[data-slot-card="${slotIdx}"]`).style.display = 'none';
          $(`[data-slot-empty="${slotIdx}"]`).style.display = '';
          $(`[data-slot="${slotIdx}"]`)?.classList.remove('has-product');
          refreshSlotTable();
          return;
        }

        /* 从 Model 下拉获取产品（兼容 S.slots 尚未设置的情况） */
        const modelSel = $(`[data-role="model"][data-slot="${slotIdx}"]`);
        const pid = modelSel?.value;
        const allProducts = S.products[S.category] || [];
        const p = allProducts.find((x) => String(x.id) === pid);
        if (!p) return;

        const variant = (p.variants || []).find((v) => String(v.id) === vid);
        if (!variant) return;

        S.slots[slotIdx] = p;
        S.slotVariant = S.slotVariant || {};
        S.slotVariant[slotIdx] = variant;

        const imgEl = $(`[data-slot-img="${slotIdx}"]`);
        if (variant.featured_image && variant.featured_image.src) {
          imgEl.src = imgSrc(variant.featured_image.src, '400x400');
        } else {
          const fallback = p.images?.[0]?.src || p.image?.src || '';
          imgEl.src = imgSrc(fallback, '400x400');
        }
        $(`[data-slot-price="${slotIdx}"]`).textContent = money(variant.price);
        const urlEl = $(`[data-slot-url="${slotIdx}"]`);
        urlEl.href = `${CFG.shopUrl}/products/${p.handle}?variant=${variant.id}`;
        refreshSlotCard(slotIdx);
        refreshSlotTable();
        $(`[data-slot="${slotIdx}"]`)?.classList.add('has-product');
      });
    });

    $$('[data-slot-remove]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const idx = btn.dataset.slotRemove;
        clearSlot(idx);
        const modelSel = $(`[data-role="model"][data-slot="${idx}"]`);
        const variantSel = $(`[data-role="variant"][data-slot="${idx}"]`);
        if (modelSel) modelSel.value = '';
        if (variantSel) {
          variantSel.innerHTML = '<option value="">Select Variant</option>';
          variantSel.disabled = true;
        }
        syncAllCombos();
      });
    });
  }

  function clearSlot(idx) {
    S.slots[idx] = null;
    if (S.slotVariant) S.slotVariant[idx] = null;
    $(`[data-slot-card="${idx}"]`).style.display = 'none';
    $(`[data-slot-empty="${idx}"]`).style.display = '';
    $(`[data-slot="${idx}"]`)?.classList.remove('has-product');
    const imgEl = $(`[data-slot-img="${idx}"]`);
    if (imgEl) {
      imgEl.removeAttribute('src');
      imgEl.alt = '';
    }
    const variantSel = $(`[data-role="variant"][data-slot="${idx}"]`);
    if (variantSel) {
      variantSel.innerHTML = '<option value="">Select Variant</option>';
      variantSel.disabled = true;
    }
    refreshSlotTable();
  }

  function resetSlots() {
    [1, 2, 3, 4].forEach((i) => clearSlot(i));
    S.slotVariant = {};
    $$('[data-role="model"]').forEach((s) => (s.value = ''));
    $$('[data-role="variant"]').forEach((s) => {
      s.innerHTML = '<option value="">Select Variant</option>';
      s.disabled = true;
    });
    syncAllCombos();
  }

  function refreshSlotCard(idx) {
    const p = S.slots[idx];
    if (!p) return;
    const sv = (S.slotVariant || {})[idx] || p.variants?.[0];
    const variantImg = sv?.featured_image?.src;
    const img = variantImg || p.images?.[0]?.src || p.image?.src || '';
    /* 标题：优先显示 variant title，回退到产品名 */
    const displayTitle = sv && sv.title && sv.title !== 'Default Title'
      ? `${p.title} - ${sv.title}`
      : p.title;
    $(`[data-slot-title="${idx}"]`).textContent = displayTitle;
    const imgEl = $(`[data-slot-img="${idx}"]`);
    imgEl.src = imgSrc(img, '400x400');
    imgEl.alt = displayTitle;
    $(`[data-slot-price="${idx}"]`).textContent = money(sv?.price || p.variants?.[0]?.price);
    const urlEl = $(`[data-slot-url="${idx}"]`);
    urlEl.href = sv
      ? `${CFG.shopUrl}/products/${p.handle}?variant=${sv.id}`
      : `${CFG.shopUrl}/products/${p.handle}`;

    $(`[data-slot-card="${idx}"]`).style.display = '';
    $(`[data-slot-empty="${idx}"]`).style.display = 'none';
  }

  function refreshSlotCards() {
    [1, 2, 3, 4].forEach((i) => {
      if (S.slots[i]) refreshSlotCard(i);
    });
  }

  /* ── 下拉对比表格 ── */
  function refreshSlotTable() {
    const filled = [1, 2, 3, 4].filter((i) => S.slots[i]);
    const tableWrap = $('[data-slot-table]');
    const emptyHint = $('[data-slot-empty-hint]');
    if (!filled.length) {
      tableWrap.style.display = 'none';
      if (emptyHint) emptyHint.style.display = '';
      return;
    }
    tableWrap.style.display = '';
    if (emptyHint) emptyHint.style.display = 'none';
    const products = filled.map((i) => S.slots[i]);
    const variantIds = filled.map((i) => {
      const sv = (S.slotVariant || {})[i];
      return sv ? String(sv.id) : null;
    });
    renderSpecTable(products, '[data-slot-thead]', '[data-slot-tbody]', variantIds);
    initDiffToggle('[data-slot-toggle-diff]', '[data-slot-tbody]');
  }

  /* ============================================================
     共享：参数表格渲染
     ============================================================ */
  /**
   * 渲染规格对比表格
   * 优先从 metafield 动态提取所有 spec key，如果 metafield 无数据则回退到 specGroups 手动配置
   */
  function renderSpecTable(products, theadSel, tbodySel, variantIds) {
    const thead = $(theadSel);
    const tbody = $(tbodySel);
    const na = CFG.labels?.na || '-';
    const colSpan = products.length + 1;
    const dragHandle = '<span class="pc-drag-handle" draggable="true" title="Drag to reorder">⠿</span>';
    const compareTitle = (product, index) => {
      const vid = variantIds?.[index];
      const variant = vid ? (product.variants || []).find((v) => String(v.id) === vid) : null;
      if (variant && variant.title && variant.title !== 'Default Title') {
        return `${product.title} - ${variant.title}`;
      }
      return product.title;
    };

    thead.innerHTML =
      '<th></th>' +
      products.map((p, i) => `<th>${compareTitle(p, i)}</th>`).join('');

    let rows = '';
    rows += `<tr data-spec-key="__price" data-no-drag>`;
    rows += `<td><strong>Price</strong></td>`;
    products.forEach((p, i) => {
      const vid = variantIds?.[i];
      const variant = vid
        ? (p.variants || []).find((v) => String(v.id) === vid)
        : p.variants?.[0];
      rows += `<td>${money(variant?.price || p.variants?.[0]?.price)}</td>`;
    });
    rows += '</tr>';

    const autoKeys = collectSpecKeys(products, variantIds);

    if (autoKeys.length) {
      rows += `<tr class="pc-group-row"><td colspan="${colSpan}">Specifications</td></tr>`;
      autoKeys.forEach((spec) => {
        rows += `<tr data-spec-key="${spec.key}">`;
        rows += `<td>${dragHandle}<strong>${spec.label}</strong></td>`;
        products.forEach((p, i) => {
          const vid = variantIds?.[i];
          const val = tagVal(p, spec.key, vid);
          rows += `<td>${val || na}</td>`;
        });
        rows += '</tr>';
      });
    } else {
      const groups = (CFG.specGroups || []).filter(
        (g) => (g.category || '').toLowerCase().trim() === S.category.toLowerCase().trim()
      );
      groups.forEach((g) => {
        rows += `<tr class="pc-group-row"><td colspan="${colSpan}">${g.name}</td></tr>`;
        (g.specs || []).forEach((spec) => {
          rows += `<tr data-spec-key="${spec.key}">`;
          rows += `<td>${dragHandle}<strong>${spec.label}</strong></td>`;
          products.forEach((p, i) => {
            const vid = variantIds?.[i];
            const val = tagVal(p, spec.key, vid);
            rows += `<td>${val || na}</td>`;
          });
          rows += '</tr>';
        });
      });
    }

    tbody.innerHTML = rows;
    initRowDrag(tbody);
    buildSpecTogglePanel(tbody);
  }

  /* ============================================================
     行拖拽排序（原生 Drag & Drop）
     ============================================================ */
  function initRowDrag(tbody) {
    let dragRow = null;

    tbody.addEventListener('dragstart', (e) => {
      const handle = e.target.closest('.pc-drag-handle');
      if (!handle) { e.preventDefault(); return; }
      dragRow = handle.closest('tr');
      if (!dragRow || dragRow.classList.contains('pc-group-row')) { e.preventDefault(); return; }
      dragRow.classList.add('is-dragging');
      e.dataTransfer.effectAllowed = 'move';
    });

    tbody.addEventListener('dragover', (e) => {
      e.preventDefault();
      e.dataTransfer.dropEffect = 'move';
      const target = e.target.closest('tr');
      if (!target || target === dragRow || target.classList.contains('pc-group-row') || target.hasAttribute('data-no-drag')) return;
      const rect = target.getBoundingClientRect();
      const mid = rect.top + rect.height / 2;
      if (e.clientY < mid) {
        tbody.insertBefore(dragRow, target);
      } else {
        tbody.insertBefore(dragRow, target.nextSibling);
      }
    });

    tbody.addEventListener('dragend', () => {
      if (dragRow) dragRow.classList.remove('is-dragging');
      dragRow = null;
    });
  }

  /* ============================================================
     参数显示/隐藏 勾选面板
     ============================================================ */
  function buildSpecTogglePanel(tbody) {
    const tableWrap = tbody.closest('.pc-table-wrap');
    if (!tableWrap) return;
    let panel = tableWrap.querySelector('.pc-spec-toggle');
    if (panel) panel.remove();

    const specRows = $$('tr[data-spec-key]', tbody);
    if (!specRows.length) return;

    panel = document.createElement('div');
    panel.className = 'pc-spec-toggle';

    let html = '<button type="button" class="pc-spec-toggle__trigger" data-spec-toggle-btn>'
      + '<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M1.5 7.5L5.5 11.5L12.5 3.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>'
      + ' Manage Columns</button>';
    html += '<div class="pc-spec-toggle__list" data-spec-toggle-list style="display:none">';
    specRows.forEach((tr) => {
      const key = tr.dataset.specKey;
      const label = tr.querySelector('td strong')?.textContent || key;
      html += `<label class="pc-spec-toggle__item"><input type="checkbox" checked data-spec-check="${key}"><span>${label}</span></label>`;
    });
    html += '</div>';
    panel.innerHTML = html;

    const actions = tableWrap.querySelector('.pc-table-actions');
    if (actions) {
      actions.appendChild(panel);
    } else {
      tableWrap.insertBefore(panel, tableWrap.querySelector('.pc-table'));
    }

    const triggerBtn = panel.querySelector('[data-spec-toggle-btn]');
    const list = panel.querySelector('[data-spec-toggle-list]');
    triggerBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      const open = list.style.display === 'none';
      list.style.display = open ? '' : 'none';
      triggerBtn.classList.toggle('is-active', open);
    });

    document.addEventListener('click', (e) => {
      if (!panel.contains(e.target)) {
        list.style.display = 'none';
        triggerBtn.classList.remove('is-active');
      }
    });

    $$('[data-spec-check]', panel).forEach((cb) => {
      cb.addEventListener('change', () => {
        const key = cb.dataset.specCheck;
        const row = tbody.querySelector(`tr[data-spec-key="${key}"]`);
        if (row) row.style.display = cb.checked ? '' : 'none';
      });
    });
  }

  function initDiffToggle(btnSel, tbodySel) {
    const btn = $(btnSel);
    const tbody = $(tbodySel);
    if (!btn || !tbody) return;
    btn.classList.remove('is-active');
    btn.onclick = () => {
      const active = btn.classList.toggle('is-active');
      highlightDiff(tbody, active);
    };
  }

  function highlightDiff(tbody, on) {
    const normalize = (s) => s.trim().toLowerCase().replace(/\s+/g, ' ');
    const rows = $$('tr', tbody);
    rows.forEach((tr) => {
      if (tr.classList.contains('pc-group-row')) return;
      const cells = $$('td', tr).slice(1);
      cells.forEach((c) => c.classList.remove('is-diff'));
      if (!on || cells.length < 2) return;
      const vals = cells.map((c) => normalize(c.textContent));
      const filled = vals.filter((v) => v && v !== '-');
      if (filled.length < 2) return;
      const allSame = filled.every((v) => v === filled[0]);
      if (!allSame) cells.forEach((c) => c.classList.add('is-diff'));
    });
  }

  /**
   * 颜色名称转 hex
   * 先精确匹配完整名称，再尝试包含关键词匹配，最后 fallback
   */
  function colorNameToHex(name) {
    const exact = {
      'black': '#1a1a1a', 'white': '#f0f0f0', 'silver': '#c0c0c0',
      'gray': '#808080', 'grey': '#808080', 'red': '#e53935',
      'blue': '#1e88e5', 'green': '#43a047', 'pink': '#f06292',
      'purple': '#8e24aa', 'orange': '#fb8c00', 'yellow': '#fdd835',
      'navy': '#283593', 'brown': '#6d4c41', 'gold': '#ffc107',
      'carbon': '#333333', 'midnight': '#191970', 'champagne': '#f7e7ce',
      'sunset orange': '#ff6f3c', 'shadow white': '#d8d8d8',
      'metallic red': '#c62828', 'metallic silver': '#b0b0b0',
      'metallic purple': '#7b1fa2', 'pearl blue': '#64b5f6',
      'coral pink': '#f48fb1', 'ice blue': '#81d4fa',
      'crystal purple': '#ce93d8', 'sakura pink': '#f8bbd0',
      'gunmetal gray': '#5c5c5c', 'gunmetal grey': '#5c5c5c',
      'space gray': '#3a3a3c', 'space grey': '#3a3a3c',
      'rose gold': '#e8b4b8', 'mint green': '#a5d6a7',
      'leviatan collab': '#1a1a1a', 'leviatan collaboration': '#1a1a1a',
      'white?': '#f0f0f0', 'black?': '#1a1a1a',
    };
    const lower = name.toLowerCase().trim();
    if (exact[lower]) return exact[lower];

    /* 关键词 fallback：从名称中提取基础颜色 */
    const keywords = [
      ['black', '#1a1a1a'], ['white', '#f0f0f0'], ['red', '#e53935'],
      ['blue', '#1e88e5'], ['pink', '#f06292'], ['purple', '#8e24aa'],
      ['orange', '#fb8c00'], ['green', '#43a047'], ['silver', '#b0b0b0'],
      ['gold', '#ffc107'], ['gray', '#808080'], ['grey', '#808080'],
      ['yellow', '#fdd835'], ['brown', '#6d4c41'],
    ];
    for (const [kw, hex] of keywords) {
      if (lower.includes(kw)) return hex;
    }
    return '#ccc';
  }

  /* ── 启动 ── */
  function boot() {
    if (!document.querySelector('[data-compare-config]')) return;
    init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /**
   * 主题编辑器会动态重新渲染 section，需要重新绑定事件
   * Shopify 在编辑器中触发 shopify:section:load 事件
   */
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target?.classList?.contains('shopify-section--product-compare')) {
      Object.keys(fetchCache).forEach((k) => delete fetchCache[k]);
      S.products = {};
      S.seriesMap = {};
      boot();
    }
  });
})();
